import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import SpineAnimation from "../../../vendor_core/core/src/views/SpineAnimation";
import Layout from "../../../vendor_core/core/src/utils/Layout";
import SceneView from "../../../vendor_core/core/src/views/SceneView";
import BURSpinModel from "../models/BURSpinModel";
import BURFeatureModel from "../models/BURFeatureModel";
import App from "../../../vendor_core/core/src/App";
import { BitmapText } from "pixi.js";
import { BitmapMoneyField } from "../../../vendor_core/core/src/views/BitmapMoneyField";
import BURReelsModel from "../models/BURReelsModel";
import BURJackpotsModel from "../models/BURJackpotsModel";
import { GameLayers } from "../enums/GameLayers";

export default class BURExitFreeSpinsState extends State {
    private hasSpineAnimation: boolean = false;
    //@ts-ignore
    private outroAnimation: SpineAnimation;
    //@ts-ignore
    protected popUpScene: SceneView;

    public async enter() {
        super.enter();
        const betBar = ViewManager.getLayer(
            DefaultLayers.BetBar
        ).getCurrentScene();
        this.popUpScene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "freespinssummary"
        );
        this.popUpScene.interactive = true;

        SoundController.playSound("free_spins_congratulations", false);
        if (this.popUpScene.spineAnimations?.has("freespinsIntroOutro")) {
            this.hasSpineAnimation = true;
            this.outroAnimation = this.popUpScene.spineAnimations.get(
                "freespinsIntroOutro"
            )!;
        }

        // Hide the bottom bitmap
        const freespinCount = this.popUpScene.sceneMoneyFields.get(
            "value"
        ) as BitmapMoneyField;
        freespinCount.visible = false;

        // Add total win
        const totalWin = new BitmapText(
            BURSpinModel.spin_total_win.toFixed(2).toLocaleString(),
            {
                fontName: "jackpot_font",
                letterSpacing: -50,
                fontSize: 156
            }
        );

        totalWin.anchor.set(0.5);

        this.outroAnimation.addChild(totalWin);

        const fsNumberBone = this.outroAnimation.skeleton.findBone(
            "number_text_preview"
        );

        const tickerCallback = () => {
            totalWin.transform.setFromMatrix(fsNumberBone!.matrix);
            totalWin.scale.y = -totalWin.scale.y;
        };

        App.instance.ticker.add(tickerCallback);

        // Play outro animation
        if (this.hasSpineAnimation) {
            this.popUpScene.orientationChangeCallback = () => {
                this.outroAnimation?.play(
                    Layout.isLandscape() ? "outro_loop" : "outro_loop_pt",
                    true
                );
            };
            this.outroAnimation
                .playAsync(
                    Layout.isLandscape() ? "outro_start" : "outro_start_pt"
                )
                .then(() => {
                    this.outroAnimation.play(
                        Layout.isLandscape() ? "outro_loop" : "outro_loop_pt",
                        true
                    );
                });
            this.popUpScene.once(PointerEvents.DOWN, async () => {
                // Show logo and hide jackpot plates
                ViewManager.getLayer(GameLayers.JackpotPlates).completeClear();
                ViewManager.getLayer(DefaultLayers.Banners).visible = true;

                // Show controller and bet buttons
                betBar.groups.get("controller")!.visible = true;
                betBar.groups.get("bet_info")!.visible = true;

                if (this.hasSpineAnimation) {
                    await this.outroAnimation.playAsync(
                        Layout.isLandscape() ? "outro_end" : "outro_end_pt"
                    );
                    this.outroAnimation.visible = false;
                }
                SoundController.playSound(SoundVars.BUTTON_CLICK);
                ViewManager.getLayer(DefaultLayers.Popups).clear();
                ViewManager.getLayer(DefaultLayers.Banners).setScene();
                SpinModel.exitFreespins();
                BetModel.clearStartBalance();
                SoundController.playMusic("idleBackgroundMusic");
                this.popUpScene.destroy();

                // Reset energy meters
                await BURReelsModel.energy_meters.onFreeSpinsExit();
                // Set the reelset index to the base game one
                BURReelsModel.setReelsetIndex(0);
                // Clear the free spins data
                BURFeatureModel.setFreeSpinsData(undefined);
                // Reset the current free spin index
                BURSpinModel.setCurrentFreeSpinIndex(-1);
                // Reset sticky wilds
                BURFeatureModel.setFeatureHasStickyWilds(false);
                // Reset jackpots
                BURJackpotsModel.resetAllJackpots();
                // Clear the total win
                App.instance.ticker.remove(tickerCallback);
                this.outroAnimation.removeChild(totalWin);
                totalWin.destroy();
                // Transition to next state
                this.exit();
            });
        }
    }
}
